import { useState, useEffect, useRef } from "react"
import MainMenu from "../MainMenu"
import Sidebar from "../Sidebar"
import AnalysisTabContent from "../Analysis/AnalysisTabContent"
import { AnalysisGrid } from "./AnalysisGrid"
import InputForm from "./InputForm"
import './css/document.css'
import './css/research.css'
import CompetitorComparison from "./CompetitorComparison"
import ResearchExamples from "./ResearchExamples"
import api from "../api/api"
import { RefreshCcw } from "lucide-react"
import Spinner from "../Spinner"
import { v4 as uuidv4 } from 'uuid';
import OutputTabs from "./OutputTab"
import OutlineToyotaTesla from './OutlineTest'
// import draftFigsTest from "./DraftFigTest"
// import draftFigsTest2 from "./DraftFigTest2"
// import draftTest from "./DraftTest"
// import testDraftContents from "./TestDraftContents"
import ResearchSidebar from "./ResearchSidebar"
import ConfirmDialog from "../utils/ConfirmDialog"
import SidebarDisplayButton from '../SidebarDisplayButton';
import DashboardModal from "../dashboard/DashboardModal"
import { useDashboardContext } from "../../context/DashboardContext"
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CloseSidebarBtn from "../CloseSidebarBtn"
import { saveAccessLog } from "../utils/commonUtils"

const Research = () => {
  const { state, dispatch } = useDashboardContext(); // Contextから取得
  const navigate = useNavigate();
  const location = useLocation();
  const [researchType, setResearchType] = useState("")
  const mainMenuRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false)
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [showDashboard, setShowDashboard] = useState(false);
  const [companyDescription, setCompanyDescription] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [showSettingArea, setShowSettingArea] = useState(false);
  const [selectedPointOfViews, setSelectedPointOfViews] = useState([]);
  const [prevPointOfViews, setPrevPointOfViews] = useState([]);
  const [prevCompanies, setPrevCompanies] = useState([]);
  const [prevAddedConditions, setPrevAddedConditions] = useState([]);
  const [addedConditions, setAddedConditions] = useState([])
  const [outline, setOutline] = useState('');
  const [showOutlineProcessing, setShowOutlineProcessing] = useState(false);
  const [showDraftProcessing, setShowDraftProcessing] = useState(false);
  const [showReportProcessing, setShowReportProcessing] = useState(false);
  const [showSlideProcessing, setShowSlideProcessing] = useState(false);
  const [showSelectCompany, setShowSelectCompany] = useState(false);
  const [addedCompanies, setAddedCompanies] = useState([]);
  const [inputMsg, setInputMsg] = useState('');
  const [showLoadingResearchType, setShowLoadingResearchType] = useState(false)  
  const [draftContents, setDraftContents] = useState("")
  const [reportContents, setReportContents] = useState("")
  const { reportId } = useParams();
  const [activeTab, setActiveTab] = useState('');
  const [draftFigs, setDraftFigs] = useState([]);
  const [reportFigs, setReportFigs] = useState([]);
  const [updateDraftFigs, setUpdateDraftFigs] = useState(false);
  const [updateReportFigs, setUpdateReportFigs] = useState(false);
  const ws = useRef(null);
  const pingInterval = useRef(null);
  const [reportList, setReportList] = useState(null);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [replaceDraftGraphFlg, setReplaceDraftGraphFlg] = useState(false);
  const [replaceSlideGraphFlg, setReplaceSlideGraphFlg] = useState(false);
  const [replaceReportGraphFlg, setReplaceReportGraphFlg] = useState(false);
  const [showDeleteOkDialog, setShowDeleteOkDialog] = useState(false);
  const [deleteReport, setDeleteReport] = useState(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [slideContents, setSlideContents] = useState(null)
  const [showQuery, setShowQuery] = useState(true);
  const [modifyOutlineButtonEnabled, setModifyOutlineButtonEnabled] = useState(false)
  const [makeReportButtonEnabled, setMakeReportButtonEnabled] = useState(true)
  const [makePptFlg, setMakePptFlg] = useState(true)

  const closeSidebarClick = () => {
      setShowSidebar(false);
  }

  const displaySidebarClick = () => {
      setShowSidebar(true);
  }

  const handleDescirptionHover = () => {

  }

  const refreshScreen = () => {
    setShowSettingArea(false);
    setShowSidebar(true);
    setActiveTab('');
    setInputMsg('')
    setSelectedCompanies([])
    setResearchType('');
    setAddedCompanies([])
    setSelectedReportId(null)
    setOutline('')
    setDraftContents('')
    setReportContents('')
    setSlideContents(null)
    setDraftFigs([])
    setShowQuery(true);
    navigate(`/research/${uuidv4()}`, { replace: true });
  }
  
  const handleAddCompany = () => {
    setSelectedCompanies((prev) => [...prev, ...addedCompanies]);
    setShowSelectCompany(false);
  }

  const handleCancelAddCompany = () => {
    setAddedCompanies([]);
    setShowSelectCompany(false);
  }

  const onCompanyClick = (secCode, companyName) => {
    if (addedCompanies.some((company) => company.secCode == secCode)) {
      setAddedCompanies(addedCompanies.filter(company => company.secCode !== secCode));

    } else {
      setAddedCompanies([...addedCompanies, {secCode: secCode, companyName: companyName}]);
    }
  }

  const onDashboardClick = (secCode) => {
    dispatch({ type: 'SET_SEC_CODE', payload: secCode})
    setShowDashboard(true);
  }

  const onDashboardCloseClick = () => {
      setShowDashboard(false);
  }

  const renderInitialStep = () => (
    <div className="space-y-4">
      <h2 className="text-xl font-bold flex gap-4"><span>レポートの種類</span>{showLoadingResearchType && <Spinner />}</h2>
      <div className="flex wrap gap-4">
        <AnalysisGrid onCardClick={setResearchType} selected={researchType} />
      </div>
    </div>
  )

  const mainMenuClick = () => {
    setShowMenu(!showMenu)
  }

  const setReportData = async (reportId) => {
    const data = await fetchResearchReport(reportId);
    if (data) {
      setReplaceDraftGraphFlg(true);
      setReplaceReportGraphFlg(true);
      setReplaceSlideGraphFlg(true);
      setActiveTab(selectActiveTab(data));
    } else {
      setShowQuery(true);
    }
  }

  useEffect(() => {
    if (reportId) {
      setSelectedReportId(reportId);
      setReportData(reportId);
      // showSettingArea(false);
    } else {
      const newId = uuidv4();
      setSelectedReportId(newId);
      navigate(`/research/${newId}`, { replace: true });
    }
    saveAccessLog('research');
  }, [reportId]);

  useEffect(() => {
    if (showOutlineProcessing || showDraftProcessing || showReportProcessing || showSlideProcessing) {
      setModifyOutlineButtonEnabled(false);
      setMakeReportButtonEnabled(false)
    } else {
      if (JSON.stringify(selectedPointOfViews) !== JSON.stringify(prevPointOfViews)) {
        setModifyOutlineButtonEnabled(true);
        setMakeReportButtonEnabled(false)
      } else if (JSON.stringify(selectedCompanies) !== JSON.stringify(prevCompanies)) {
        setModifyOutlineButtonEnabled(true);
        setMakeReportButtonEnabled(false)
      } else if (JSON.stringify(addedConditions) !== JSON.stringify(prevAddedConditions)) {
        setModifyOutlineButtonEnabled(true);
        setMakeReportButtonEnabled(false)
      } else {
        setModifyOutlineButtonEnabled(false);
        setMakeReportButtonEnabled(true)
      }
    }
  }, [selectedPointOfViews, addedConditions, selectedCompanies, prevCompanies, prevAddedConditions, prevPointOfViews, showOutlineProcessing, showDraftProcessing, showReportProcessing, showSlideProcessing])

  const specifyCompanies = async (msg) => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/chat/api/classify-research-settings/`, 
        {
          query: msg,
          task: "specify-companies"
        }
      );
      
      const targetCompanies = response.data.classification
      return targetCompanies

    } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // 未認証の場合、ログイン画面にリダイレクト
          navigate('/login', { state: { from: location.pathname } });
      } else {
          console.error('Error fetching chat list:', error);
      }
    }
  }

  const specifySettings = async (msg) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_URL}/chat/api/classify-research-settings/`, 
        {
            query: msg, 
            task: "classify-research-settings"
        }
      )
      const settings = response.data.classification
      return settings

    } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // 未認証の場合、ログイン画面にリダイレクト
          navigate('/login', { state: { from: location.pathname } });
      } else {
          console.error('Error fetching list:', error);
      }
  }
  }

  const classifyResearchSettings = async (msg, setSelectedCompanies, setResearchType, setSelectedPointOfViews) => {
    const results = await Promise.allSettled([
      specifyCompanies(msg).then(result => ({ key: "targetCompanies", data: result })),
      specifySettings(msg).then(result => ({ key: "researchSettings", data: result }))
    ]);
  
    // 初期値をセット（デフォルト値を入れる）
    let targetCompanies = [];
    let researchType = "others";  // デフォルト値
    let pointOfViews = [];
    let addedConditions = [];
  
    results.forEach(result => {
      if (result.status === "fulfilled") {  // 成功したもののみ処理
        if (result.value.key === "targetCompanies") {
          targetCompanies = result.value?.data || [];  // デフォルト値
          setSelectedCompanies(targetCompanies);
          setPrevCompanies(targetCompanies)
        } else if (result.value.key === "researchSettings") {
          researchType = result.value.data?.researchType || "others";  // デフォルト値
          setResearchType(researchType);
          
          pointOfViews = result.value.data?.pointOfViews || [];  // デフォルト値
          setSelectedPointOfViews(pointOfViews);
          setPrevPointOfViews(pointOfViews)
          addedConditions = result.value.data?.addedConditions || [];  // デフォルト値
          setAddedConditions(addedConditions);
          setPrevAddedConditions(addedConditions)
        }
      } else {
        console.error(`Error in ${result.reason}`);
      }
    });
    return { targetCompanies, researchType, pointOfViews };
  };

  useEffect(() => {
    if (selectedReportId) {
      setShowQuery(false)
    }
  }, [selectedReportId])

  const makeOutline = async (msg, targetCompanies=[], researchType='', pointOfViews=[], addedConditions=[]) => {
    setShowDashboard(false)
    // setOutline(OutlineToyotaTesla)
    
    try {
      const response = await api.post(`${process.env.REACT_APP_API_URL}/chat/api/make-outline/${reportId}/`, 
        {
            query: msg, 
            research_type: researchType,
            target_companies: targetCompanies.map((c) => c.secCode),
            pov: pointOfViews, 
            added_conditions: addedConditions,
            chatId: reportId,
        }
      )
      setShowOutlineProcessing(false)

    } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // 未認証の場合、ログイン画面にリダイレクト
          navigate('/login', { state: { from: location.pathname } });
      } else {
          console.error('Error fetching report list:', error);
      }
      setShowOutlineProcessing(false)
    }
  }
  
  const runProcess = async (msg) => {
    setShowSettingArea(true); 
    setShowSidebar(false); 
    setShowLoadingResearchType(true)
    setShowOutlineProcessing(true)
    const {targetCompanies, researchType, pointOfViews } = await classifyResearchSettings(msg, setSelectedCompanies, setResearchType, setSelectedPointOfViews);
    setShowLoadingResearchType(false)
    
    setActiveTab('アウトライン')
    makeOutline(msg, targetCompanies, researchType, pointOfViews)
    setShowQuery(false);
  };

  const modifyOutline = () => {
    setOutline('');
    setPrevCompanies([...selectedCompanies]);
    setPrevPointOfViews([...selectedPointOfViews]);
    setPrevAddedConditions([...addedConditions]);
    
    runModifyOutline(inputMsg, selectedCompanies, researchType, selectedPointOfViews, addedConditions, outline)
  }
  
  const runModifyOutline = async (msg, targetCompanies=[], researchType='', pointOfViews=[], addedConditions=[], outline='') => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_URL}/chat/api/modify-outline/${reportId}/`, 
        {
            query: msg, 
            research_type: researchType,
            target_companies: targetCompanies.map((c) => c.secCode), 
            pov: pointOfViews, 
            added_conditions: addedConditions,
            outline: outline,
        }
      )
      
    } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // 未認証の場合、ログイン画面にリダイレクト
          navigate('/login', { state: { from: location.pathname } });
      } else {
          console.error('Error fetching chat list:', error);
      }
    }
  }
  
  const runMakeDraft = async (msg, targetCompanies=[], researchType='', pointOfViews=[], addedConditions=[], outline='') => {
    setActiveTab('ドラフト')
    setReplaceDraftGraphFlg(false);
    setShowDraftProcessing(true);
    setUpdateDraftFigs(false)
    setReplaceDraftGraphFlg(false);
    setDraftContents('')
    setDraftFigs([])

    // ★★★ テスト用
    // setDraftContents(testDraftContents)
    // setReplaceGraphFlg(true);
    // ★★★ テスト用

    try {
      const response = await api.post(`${process.env.REACT_APP_API_URL}/chat/api/make-draft/${reportId}/`, 
        {
            query: msg, 
            research_type: researchType,
            target_companies: targetCompanies.map((c) => c.secCode), 
            pov: pointOfViews, 
            added_conditions: addedConditions,
            outline: outline,
            chatId: reportId,
        }
      )
      setUpdateDraftFigs(true)
      setShowDraftProcessing(false);
      setReplaceDraftGraphFlg(true);
      return response
    } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // 未認証の場合、ログイン画面にリダイレクト
          // navigate('/login', { state: { from: location.pathname } });
      } else {
          console.error('Error fetching chat list:', error);
      }
      setShowDraftProcessing(false);
    }
  }


  const runMakeReport = async (msg, targetCompanies=[], researchType='', pointOfViews=[], addedConditions=[], outline='') => {
    setActiveTab('レポート')
    setReportContents('')
    setReportFigs([])
    setUpdateReportFigs(false);
    setReplaceReportGraphFlg(false);
    setShowReportProcessing(true);
    // ★★★ テスト用
    // setDraftContents(testDraftContents)
    // setReplaceGraphFlg(true);
    // ★★★ テスト用

    try {
      const response = await api.post(`${process.env.REACT_APP_API_URL}/chat/api/make-report/${reportId}/`, 
        {
            query: msg, 
            research_type: researchType,
            target_companies: targetCompanies.map((c) => c.secCode), 
            pov: pointOfViews, 
            added_conditions: addedConditions,
            outline: outline,
            chatId: reportId,
        }
      )
      setUpdateReportFigs(true)
      setShowReportProcessing(false);
      setReplaceReportGraphFlg(true);
      return response
    } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // 未認証の場合、ログイン画面にリダイレクト
          navigate('/login', { state: { from: location.pathname } });
      } else {
          console.error('Error fetching chat list:', error);
      }
      setShowReportProcessing(false);
    }
  }

  const runMakeSlide = async (msg, targetCompanies=[], researchType='', pointOfViews=[], addedConditions=[], outline='') => {
    setActiveTab('スライド')
    setSlideContents("")
    setReplaceSlideGraphFlg(false)
    setShowSlideProcessing(true)
    // ★★★ テスト用
    // setDraftContents(testDraftContents)
    // setReplaceGraphFlg(true);
    // ★★★ テスト用

    try {
      const response = await api.post(`${process.env.REACT_APP_API_URL}/chat/api/make-slide/${reportId}/`, 
        {
            query: msg, 
            research_type: researchType,
            target_companies: targetCompanies.map((c) => c.secCode), 
            pov: pointOfViews, 
            added_conditions: addedConditions,
            outline: outline,
            chatId: reportId,
        }
      )
      setShowSlideProcessing(false);
      setReplaceSlideGraphFlg(true)
      return response
    } catch (error) {
      
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // 未認証の場合、ログイン画面にリダイレクト
          navigate('/login', { state: { from: location.pathname } });
      } else {
          console.error('Error fetching chat list:', error);
      }
    }

  }

  const onMakeReportClick = async () => {
    const title = "作成中..."
    setReportList((prev) => [{reportId: reportId, title: title}, ...prev])
    await runMakeDraft(inputMsg, selectedCompanies, researchType, selectedPointOfViews, addedConditions, outline)
    fetchResearchReportList();
    await runMakeReport(inputMsg, selectedCompanies, researchType, selectedPointOfViews, addedConditions, outline)
    if (makePptFlg) {
      await runMakeSlide(inputMsg, selectedCompanies, researchType, selectedPointOfViews, addedConditions, outline)
    }
  }
    
  const onMakeSlideClick = () => {
    runMakeSlide(inputMsg, selectedCompanies, researchType, selectedPointOfViews, addedConditions, outline)
  }

  const handleExampleClick = (example) => {
    setInputMsg(example)
  }

  useEffect(() => {
    if (!reportId) return;

    let reconnectTimer;
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';

    const connectWebSocket = () => {
      if (!ws.current || ws.current.readyState !== WebSocket.OPEN) {
        ws.current = new WebSocket(
          `${protocol}://${process.env.REACT_APP_WS_URL}/ws/create-document/${reportId}/`
        );
      }

      ws.current.onopen = () => {
        // 接続が確立したら、30秒ごとに ping メッセージを送信
        pingInterval.current = setInterval(() => {
          if (ws.current.readyState === WebSocket.OPEN) {
            // サーバ側で ping 用の処理が実装されている場合は、ここでカスタムメッセージを送信
            ws.current.send(JSON.stringify({ type: 'ping' }));
          }
        }, 30000);
      };

      ws.current.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.operation_type === 'utterance') {
          setOutline(data.operation);
        } else if (data.operation_type === 'final-report') {
          setReportContents(data.operation);
        } else if (data.operation_type === 'draft') {
          setDraftContents(data.operation);
        } else if (data.operation_type === 'slide') {
          setSlideContents(data.operation);
        } else if (data.operation_type === 'make_graph') {
          setDraftFigs((prev) => [...prev, data.fig_data]);
        }
      };

      ws.current.onerror = (event) => {
        console.error('WebSocket エラー:', event);
      };

      ws.current.onclose = (event) => {
        clearInterval(pingInterval.current);
        // 再接続のために少し待ってから再度接続処理を呼び出す
        reconnectTimer = setTimeout(() => {
          connectWebSocket();
        }, 5000);
      };
    };

    connectWebSocket();

    // クリーンアップ処理：コンポーネントのアンマウント時、もしくは reportId 変更時に接続をクローズ
    return () => {
      clearInterval(pingInterval.current);
      clearTimeout(reconnectTimer);
      if (ws.current) {
        ws.current.close();
        console.log('WebSocket 手動切断');
      }
    };
  }, [reportId]);

  const fetchResearchReportList = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/research-report-list/`);
        setReportList(response.data.reports); // データを state にセット
      } catch (error) {
          if (error.response && (error.response.status === 401 || error.response.status === 403)) {
              navigate('/login', { state: { from: location.pathname } });
          } else {
              console.error('Error fetching insight note list:', error);
          }
      }
  };

  const fetchResearchReport = async (reportId) => {
    try {
      const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/research-report/${reportId}/`);
      const data = response.data
      if (!data) {
        return;
      }
      setOutline(data.outline.content)
      if (!data.draft.is_updating) {
        setDraftContents(data.draft.content)
      }
      
      setReportContents(data.report.content)
      setSlideContents(data.slide.content)
      setResearchType(data.outline.research_type)
      setSelectedPointOfViews(data.outline.point_of_views)
      setPrevPointOfViews(data.outline.point_of_views)
      setPrevAddedConditions(data.outline.additional_conditions)
      setAddedConditions(data.outline.additional_conditions)
      setSelectedCompanies(
        data.target_companies.map((company) => ({
          secCode: company.sec_code,
          companyName: company.company_name
        }))
      );
      setPrevCompanies(
        data.target_companies.map((company) => ({
          secCode: company.sec_code,
          companyName: company.company_name
        }))
      );
      return data
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // 認証エラーの場合はログインページへリダイレクト（コメントアウト中）
            // navigate('/login', { state: { from: location.pathname } });
        } else {
            console.error('Error fetching research report:', error);
        }
    }
  };

  useEffect(() => {
    fetchResearchReportList(); // コンポーネントの初回読み込み時にノートリストを取得
  }, [])
 
  const selectActiveTab = (reportData) => {
    if (!reportData) {
      return "アウトライン"
    }

    if (reportData.slide.content) {
      return "スライド"
    } else if (reportData.report.content) {
      return "レポート"
    } else if (reportData.draft.content) {
      return "ドラフト"
    } else if (reportData.outline.content) {
      return "アウトライン"
    } else {
      return "アウトライン"
    }
  }
  
  const onReportSelect = async (reportId) => {
    // setShowSettingArea(true); 
    if (reportId !== selectedReportId) {
      setSelectedReportId(reportId);
    }
    navigate(`/research/${reportId}`, { replace: true });
  }

  const onDeleteButtonClick = (reportId, title) => {
    setDeleteReport({id: reportId, title: title});
    setShowDeleteOkDialog(true);
  }

  const onDeleteOkClick = async () => {
    try {
        const reportId = deleteReport.id;
        // DELETEリクエストを送信
        const response = await api.delete(`${process.env.REACT_APP_API_URL}/chat/api/research-report/${reportId}/delete/`);

        if (response.status === 200) {
            await fetchResearchReportList(); // ノートリストをリフレッシュ
        } else {
            console.error("Failed to delete note");
        }
        setShowDeleteOkDialog(false);
    } catch (error) {
        console.error("Error deleting note:", error);
    }
  };

  const onCancelClick = () => {
      setShowDeleteOkDialog(false);
  }

  const closeSettingAreaClick = () => {
    setShowSettingArea(false);
  }

  const displaySettingAreaClick = () => {
    setShowSettingArea(true);
  }

  return (
    <>
      <MainMenu ref={mainMenuRef} handleClick={mainMenuClick} />
      <div className="main-container relative flex">
        <Sidebar selectedIcon="research" showMenu={showMenu} />
        {showDashboard && <DashboardModal closeClickFunction={onDashboardCloseClick} />}
        {showSidebar ?
          <ResearchSidebar
            reportList={reportList}
            selectedReportId={selectedReportId}
            onReportSelect={onReportSelect}
            onDeleteButtonClick={onDeleteButtonClick} 
            closeSidebarClick={closeSidebarClick} 
            />
          : 
          <SidebarDisplayButton displaySidebarClick={displaySidebarClick}/>
        }
        <div className={`w-full overflow-y-auto flex z-[1500]`}>
          {showSettingArea ? (
            <div
              className={`p-6 bg-white w-[600px] z-[1500] h-full relative shadow-xl transform transition-transform duration-300 ease-in-out overflow-y-auto 
                ${showSidebar ? '' : 'ml-[90px]'}
                translate-x-0`}
            >
              <CloseSidebarBtn onClick={closeSettingAreaClick} hoverBgColor="bg-gray-200" tooltipMessage="設定エリアを閉じる" tooltipRight="right-[0px]" />
              <div className="py-2 mb-5">{renderInitialStep()}</div>
              {researchType && (
                <div className="py-2">
                  <CompetitorComparison 
                    researchType={researchType}
                    selectedCompanies={selectedCompanies}
                    setSelectedCompanies={setSelectedCompanies}
                    setShowSelectCompany={setShowSelectCompany}
                    selectedPointOfViews={selectedPointOfViews}
                    setSelectedPointOfViews={setSelectedPointOfViews}
                    addedConditions={addedConditions}
                    setAddedConditions={setAddedConditions}
                    modifyOutline={modifyOutline}
                    processCreateReport={onMakeReportClick}
                    onMakeSlideClick={onMakeSlideClick}
                    modifyOutlineButtonEnabled={modifyOutlineButtonEnabled}
                    makeReportButtonEnabled={makeReportButtonEnabled}
                    makePptFlg={makePptFlg}
                    setMakePptFlg={setMakePptFlg}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={`absolute z-[3000] ${showSidebar ? "top-[5px] left-[310px]" : "top-[0px] left-[20px]"}`}>
              <SidebarDisplayButton displaySidebarClick={displaySettingAreaClick} hoverBgColor="bg-gray-200" tooltipMessage="設定エリアを表示する"/>
            </div>
          )}
          <div className={`py-4 pl-[30px] pr-[30px] flex flex-1 justify-center z-[1000]`}>
            <div className="flex justify-center w-full">
              <div className="w-full max-w-[1200px] flex flex-col">
                <div className="text-2xl mb-4 flex gap-4 items-center"><span>Insight Research</span><div className="p-2 rounded-[100%] hover:bg-gray-300"><RefreshCcw size={16} onClick={refreshScreen} /></div></div>
                  {showQuery && 
                    <>
                      <div>
                        <InputForm runProcess={runProcess} inputMsg={inputMsg} setInputMsg={setInputMsg} />
                      </div>
                      <ResearchExamples handleClick={handleExampleClick}/>
                    </>
                  }
                  {activeTab !== '' && <OutputTabs
                    activeTabName={activeTab}
                    outline={outline}
                    setOutline={setOutline}
                    draftContents={draftContents}
                    draftFigs={draftFigs}
                    reportFigs={reportFigs}
                    updateDraftFigs={updateDraftFigs}
                    updateReportFigs={updateReportFigs}
                    reportContents={reportContents}
                    showOutlineProcessing={showOutlineProcessing}
                    showDraftProcessing={showDraftProcessing}
                    showReportProcessing={showReportProcessing}
                    showSlideProcessing={showSlideProcessing}
                    replaceDraftGraphFlg={replaceDraftGraphFlg}
                    replaceReportGraphFlg={replaceReportGraphFlg}
                    replaceSlideGraphFlg={replaceSlideGraphFlg}
                    slideContents={slideContents}
                  />}
                </div>
              </div>
            </div>
          </div>

          {showDeleteOkDialog && <ConfirmDialog message={`「${deleteReport.title}」を削除してもよいですか？`} onOkClick={onDeleteOkClick} onCancelClick={onCancelClick} />}
          {showSelectCompany &&
            <div className="fixed inset-0 bg-gray-500 bg-opacity-50 z-50 flex items-center justify-center z-[3000]">
            <div className="bg-white p-6 rounded-lg shadow-lg z-60 w-[80%] h-[800px] ">
              <div className="h-[700px] overflow-y-auto">
                <AnalysisTabContent 
                  selectedCompanies={[...selectedCompanies, ...addedCompanies]} 
                  onCompanyClick={onCompanyClick} 
                  onDashboardClick={onDashboardClick} 
                  showStatus={showStatus} 
                  addAllCompanies={null} 
                  companyDescription={companyDescription} 
                  setCompanyDescription={setCompanyDescription} 
                  handleOpenAnalylis={null} 
                  analysisAreaOpend={false} 
                />
              </div>
              <div className="flex justify-end mt-4 h-[45px] gap-2">
                <button 
                  className="flex items-center gap-2 px-4 py-2 rounded-full border border-gray-300 hover:bg-gray-50 transition-colors duration-200"
                  onClick={handleCancelAddCompany}
                >
                  <span className="mr-2">キャンセル</span>
                </button>
                <button 
                  className="flex items-center gap-2 px-6 py-2 rounded-full bg-gradient-to-r from-emerald-500 to-teal-400 shadow-lg hover:from-emerald-600 hover:to-teal-500 text-white transition-colors duration-200"
                  onClick={handleAddCompany}
                  >
                  <span>OK</span>
                </button>
              </div>
            </div>
          </div>
          }
      </div>
    </>
  )
}

export default Research

